export default "__VITE_ASSET__DQRLk8Jx__"